import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, Flip, SplitText);

gsap.defaults({
    ease: "expo.out",
    duration: 0.6,
});

gsap.config({
    nullTargetWarn: true,
    autoSleep: 60,
    force3D: false,
});
